var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleavatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2006_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2007_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2008_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2009_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2010_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2011_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2012_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2013_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2014_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2015_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2016_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2017_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2018_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2019_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 68.29-26.74 130.33-70.31 176.23-46.65 49.13-112.59-20.92-185.69-20.92s-139.04 70.05-185.69 20.92c-43.57-45.9-70.31-107.94-70.31-176.23 0-141.38 114.62-256 256-256 135.48 0 246.39 105.26 255.4 238.46.4 5.8.6 11.64.6 17.54z",
    fill: "#5de9f4"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 68.29-26.74 130.33-70.31 176.23-46.65 49.13-112.59-20.92-185.69-20.92l-118.82-118.82 207.43-220.82 166.79 166.79c.4 5.8.6 11.64.6 17.54z",
    fill: "#4bc5ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.339 33.459h-4.678c-64.33 0-116.479 52.15-116.479 116.479v142.555h237.636v-142.555c0-64.33-52.149-116.479-116.479-116.479z",
    fill: "#ea9611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.82 149.94v142.55h-118.82v-259.03h2.34c64.33 0 116.48 52.15 116.48 116.48z",
    fill: "#af5e22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.97 250.232h112.06v118.84h-112.06z",
    fill: "#336b90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 250.236h56.03v118.84h-56.03z",
    fill: "#205077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.69 381.46v50.77c-46.65 49.13-112.59 79.77-185.69 79.77s-139.04-30.64-185.69-79.77v-50.77c0-29.92 24.25-54.17 54.17-54.17h263.04c29.92 0 54.17 24.25 54.17 54.17z",
    fill: "#205077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.69 381.46v50.77c-46.65 49.13-112.59 79.77-185.69 79.77v-184.71h131.52c29.92 0 54.17 24.25 54.17 54.17z",
    fill: "#17416b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.33 405.45v86.82c-11.17-4.66-21.95-10.11-32.25-16.25v-70.57z",
    fill: "#17416b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.92 405.45v70.57c-10.3 6.14-21.08 11.59-32.25 16.25v-86.82z",
    fill: "#092e4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.251 152.225c-3.728-56.6-49.511-77.517-88.251-77.517s-84.523 20.917-88.251 77.517c-10.018 1.938-17.134 15.077-16.014 25.701l1.717 24.177c1.175 11.157 10.982 19.301 21.79 18.089l1.864-.202c22.138 59.446 56.857 65.644 78.894 69.125 22.038-3.48 56.756-9.678 78.894-69.125l1.864.202c10.807 1.212 20.614-6.932 21.79-18.089l1.717-24.177c1.12-10.624-5.996-23.763-16.014-25.701z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.265 177.926-1.717 24.177c-1.175 11.157-10.982 19.301-21.79 18.089l-1.864-.202c-7.566 20.293-16.592 34.388-26.078 44.277-18.291 19.081-38.299 22.552-52.817 24.847v-214.406c38.74 0 84.523 20.917 88.251 77.517 10.019 1.938 17.135 15.077 16.015 25.701z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 40.977c-149.782 0-102.548 161.126-102.548 161.126l30.899-50.473 15.619 30.282 56.03-60.372 56.03 60.371 15.619-30.282 30.898 50.473c.001.001 47.235-161.125-102.547-161.125z",
    fill: "#ea9611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.55 202.1-30.9-50.47-15.62 30.28-56.03-60.37v-80.56c149.78 0 102.55 161.12 102.55 161.12z",
    fill: "#af5e22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleavatar3);
export default __webpack_public_path__ + "static/media/Femaleavatar_3.26f06dfaea80b14879c5c45bb3546df2.svg";
export { ForwardRef as ReactComponent };